import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { TableCell, TableRow, IconButton, Box } from '@material-ui/core';
import { Edit, Delete, Check, Close } from '@material-ui/icons';
import { StatusCode } from '../../domain/constants/StatusCode';
import ModalBarcode from '../common/ModalBarcode';
import { useSyles } from './styles.style';
// Redux
import { useDispatch } from 'react-redux';
import { updateWarehouse } from '../../redux/warehouses/thunks';

const Warehouse = ({ warehouse }) => {
  const classes = useSyles();
  const { name, address, id, barcode, status_warehouses_id } = warehouse;

  const dispatch = useDispatch();
  const navigate = useNavigate(); // habilitar navigate para redirección

  const [showBarcode, setShowBarcode] = useState(false);

  // Confirmar si desea eliminarlo
  const confirmDeleteWarehouse = (warehouse) => {
    // preguntar al usuario
    Swal.fire({
      title: '¿Estas seguro?',
      text: 'Un almacen que se elimina no se puede recuperar',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FF5958',
      cancelButtonColor: '#C0BFC2',
      confirmButtonText: 'Si, eliminar!!',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        // pasarlo al action
        changeStatusWarehouse(warehouse, StatusCode.deleted, 'Eliminado');
      }
    });
  };

  // función que redirige de forma programada
  const redirectEdition = (id) => {
    navigate(`/warehouses/edit/${id}`, { replace: true });
  };

  const changeStatusWarehouse = (warehouse, status, text) => {
    const values = { ...warehouse };
    values['status_warehouses_id'] = status;
    dispatch(updateWarehouse({ values, status, text }))
      .unwrap()
      .then((res) => {
        setTimeout(function () {
          navigate(0);
        }, 1000);
      });
  };

  const ActiveButton = () => {
    return (
      <>
        {status_warehouses_id === StatusCode.active ? (
          <IconButton
            aria-label='check'
            size='medium'
            title='desactivar el almacén'
            onClick={() =>
              changeStatusWarehouse(
                warehouse,
                StatusCode.inactive,
                'Desactivado'
              )
            }
          >
            <Check className={classes.check} />
          </IconButton>
        ) : (
          <IconButton
            aria-label='check'
            size='medium'
            title='activar el almacén'
            onClick={() =>
              changeStatusWarehouse(warehouse, StatusCode.active, 'Activado')
            }
          >
            <Close color='error' />
          </IconButton>
        )}
      </>
    );
  };

  return (
    <TableRow key={id}>
      <TableCell component='th' scope='row'>
        {id}
      </TableCell>
      <TableCell>{name}</TableCell>
      <TableCell>{address}</TableCell>
      <TableCell>
        <Box sx={{ textAlign: 'center', width: 'max-content', margin: 'auto' }}>
          <IconButton
            aria-label='editar'
            size='medium'
            onClick={() => setShowBarcode(true)}
            title='imprimir código'
            variant='outlined'
          >
            <img width='25px' src='/barcode-icon.svg' alt='' />
          </IconButton>
          <Box sx={{ fontSize: '10px' }}>{barcode}</Box>
        </Box>
      </TableCell>
      <TableCell>
        <ActiveButton />
      </TableCell>
      <TableCell align='right'>
        <IconButton
          aria-label='editar'
          size='medium'
          onClick={() => redirectEdition(warehouse.id)}
        >
          <Edit color='action' />
        </IconButton>
        {/* TODO: The API to delete a warehouse is failing. */}
        {/* <IconButton
          aria-label='borrar'
          size='medium'
          onClick={() => confirmDeleteWarehouse(warehouse)}
        >
          <Delete />
        </IconButton> */}
      </TableCell>
      {showBarcode && (
        <ModalBarcode barcode={barcode} onClose={() => setShowBarcode(false)} />
      )}
    </TableRow>
  );
};

export default Warehouse;
